import { render } from "./DynamicContainer.vue?vue&type=template&id=5db800f7"
import script from "./DynamicContainer.vue?vue&type=script&lang=js"
export * from "./DynamicContainer.vue?vue&type=script&lang=js"

import "./DynamicContainer.vue?vue&type=style&index=0&id=5db800f7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__